/*
 * Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular
        .module('askApp')
        .controller('AddressController', AddressController);

    AddressController.$inject = ['PrincipalProfile', 'Auth', 'AlertService', '$translate'];

    function AddressController (PrincipalProfile, Auth, AlertService, $translate) {

        var vm = this;

        vm.profile = null;
        vm.save = save;

        PrincipalProfile.identity(true).then(function(profile) {
            vm.profile = profile;
        });

        function save () {
            vm.isSaving = true;
            Auth.updateProfile(vm.profile).then(function() {
                vm.error = null;
                vm.isSaving = false;
                PrincipalProfile.identity(true).then(function(profile) {
                    vm.profile = profile;
                });
                AlertService.success($translate.instant('global.messages.update.alert'));
            }).catch(function() {
                vm.isSaving = false;
                vm.error = 'ERROR';
            });
        }
    }
})();
